(function () {
  /**
   * @ngdoc module
   * @name binky.core.api.clype
   * @description module that defines clype api resource services
   */
  angular.module('binky.core.api.clype', ['ngResource']);
})();
